import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { from, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
// import * as mimetype from 'mimetype';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as pdfjsLib from 'pdfjs-dist';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AwsService {
  private accessKey = environment.BUCKET_ACCESS_KEY;
  private secretKey = environment.BUCKET_SECRET;
  private bucketName = environment.BUCKET_NAME;
  private bucketUrl = environment.BUCKET_URL;
  s3: AWS.S3;
  currentTime: string;
  private confirmModal?: NzModalRef;

 

  constructor(private modal: NzModalService, private sanitizer: DomSanitizer,private http: HttpClient) {
    AWS.config.update({
      accessKeyId: this.accessKey,
      secretAccessKey: this.secretKey,
    });
    this.s3 = new AWS.S3();



  }

  // getFileMimeType(filename) {
  //   const extension = filename.split('.').pop();
  //   let mimeType;

  //   switch (extension.toLowerCase()) {
  //     case 'pdf':
  //       mimeType = 'application/pdf';
  //       break;
  //     case 'xlsx':
  //       mimeType =
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  //       break;
  //     case 'doc':
  //     case 'docx':
  //       mimeType = 'application/msword';
  //       break;
  //     case 'png':
  //       mimeType = 'image/png';
  //       break;
  //     case 'jpg':
  //     case 'jpeg':
  //       mimeType = 'image/jpeg';
  //       break;
  //     case 'mp4':
  //       mimeType = 'video/mp4';
  //       break;
  //     default:
  //       mimeType = mime.lookup(filename) || 'application/octet-stream';
  //   }

  //   return mimeType;
  // }

// getMimeType(fileName: string): string {
//   const mimeType = mimetype.lookup(fileName);
//   return mimeType || 'Unknown';
// }


  getFileExtension(fileName) {
    const parts = fileName.split('.');
    const extension = parts[parts.length - 1];
    return extension.toLowerCase();
  }

  // uploadFile(file: any, filename): Promise<any> {
  //   // const unixTimestamp = Date.now();
  //   // const fileExtension = this.getFileExtension(file.name);
  //   // const combinedFileName = `${unixTimestamp}.${fileExtension}`;
  //   const params = {
  //     Bucket: this.bucketName,
  //     Key: filename,
  //     // Key: file.name, // The name of the file in S3
  //     Body: file, // The file itself
  //     ContentDisposition: 'inline',
  //     // ContentType: this.getFileMimeType(filename) 
  //     ContentType: 'application/pdf'
  //   };

  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.s3.putObject(params, (err, data) => {
  //         if (err) {
  //           console.error('Error uploading file to S3:', err);
  //           reject(err);
  //         } else {
  //           console.log('File uploaded successfully to S3:', data);
  //           resolve(data);
  //         }
  //       });
  //     } catch (error) {
  //       console.error('Error in try-catch block:', error);
  //       reject(error);
  //     }
  //   });
  // }

  uploadFile(file, filename,progressCallback?: (progress: number) => void) {
    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const getFileContentType = (extension) => {
        switch (extension) {
            case 'pdf':
                return 'application/pdf';
            case 'xlsx':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'png':
                return 'image/png';
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'mp4':
                return 'video/mp4';
            case 'gif':
                return 'image/gif';
            case 'doc':
            case 'docx':
                return 'application/msword';
            default:
                return 'application/octet-stream';
        }
    };

    const params = {
        Bucket: this.bucketName,
        Key: filename,
        Body: file,
        ContentDisposition: 'inline',
        ContentType: getFileContentType(getFileExtension(filename))
    };

    return new Promise((resolve, reject) => {
        try {
            const upload = this.s3.upload(params); 
            
          // Attach a progress listener
          upload.on('httpUploadProgress', (event) => {
            if (progressCallback) {
              const progress = Math.round((event.loaded / event.total) * 100);
              progressCallback(progress); // Report progress to the caller
            }
          });


          upload.send((err, data) => {
            if (err) {
              console.error('Error uploading file to S3:', err);
              reject(err);
            } else {
              console.log('File uploaded successfully to S3:', data);
              resolve(data);
          }});
          } catch (error) {
            console.error('Error in try-catch block:', error);
            reject(error);
          }
    });
}
  //parameter: thunbnail Actuall File(image), File name
  uploadThumbnail(thumbnailFile, thumbnailName) {
    console.log("this is thumbnail file", thumbnailFile,thumbnailName)

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const getFileContentType = (extension) => {
      switch (extension) {
          case 'pdf':
              return 'application/pdf';
          case 'xlsx':
              return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          case 'png':
              return 'image/png';
          case 'jpg':
          case 'jpeg':
              return 'image/jpeg';
          case 'mp4':
              return 'video/mp4';
          case 'gif':
              return 'image/gif';
          case 'doc':
          case 'docx':
              return 'application/msword';
          default:
              return 'application/octet-stream';
      }
    };
    const folderName = 'thumbnail';

    if(!thumbnailName){
      return null;
    }

    // path on S3: thumbnail/<file-name>.<extension>
    const params = {
      Bucket: this.bucketName,
      Key: `${folderName}/${thumbnailName}`,
      Body: thumbnailFile,
      ContentDisposition: 'inline',
      ContentType: getFileContentType(getFileExtension(thumbnailName)),
    };
    console.log("this is params in thumbnail", params)

    return new Promise((resolve, reject) => {
      try {
        this.s3.upload(params, (err, data) => {
          if (err) {
            console.error('Error uploading file to S3:', err);
            reject(err);
          } else {
            console.log('Thumbnail uploaded successfully to S3:', data);
                  
            const file_Key = `${folderName}/${thumbnailName}`;
            

            resolve(file_Key);
          }
        });
      } catch (error) {
        console.error('Error in try-catch block:', error);
        reject(error);
      }
    });

  };

  base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64.split(',')[1]); // Decode Base64
    const byteNumbers = new Array(byteCharacters.length);
  
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
  
    return new Blob([byteArray], { type: mimeType });
  }

  generateThumbnail(file: File): Promise<string> {

    console.log("This is file",file);

    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      console.log("fileReader", fileReader);
      fileReader.onload = async () => {

        const pdfData = new Uint8Array(fileReader.result as ArrayBuffer);
        console.log("pdfData", pdfData);

        try {

          pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf/pdf.worker.min.js';
          // Load the PDF document
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          console.log("this is pdf", pdf);
          const page = await pdf.getPage(1);
          console.log("this is page", page);


          // Set up canvas
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d')!;
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          };

          // Render the page
          await page.render(renderContext).promise;
          resolve(canvas.toDataURL()); // Return the base64 image
        } catch (error) {
          reject(`Error rendering PDF: ${error}`);
        }
      };

      fileReader.onerror = (error) => {
        reject(`FileReader error: ${error}`);
      };

      fileReader.readAsArrayBuffer(file); // Read file as ArrayBuffer
    });
  
  }

  generateVideoThumbnail(file: File): Promise<string> {
    console.log("This is vide file", file);
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
    
        if (!context) {
          reject('Canvas context is not supported.');
          return;
        }
    
        video.src = URL.createObjectURL(file);
        console.log("this is video src",video.src)
        video.currentTime = 1; // Capture frame at 1 second
    
        video.onloadeddata = () => {
          video.addEventListener('seeked', () => {
            // Set canvas size to video frame size
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
    
            // Draw video frame on canvas
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
    
            // Get Base64 string from the canvas
            const imageData = canvas.toDataURL('image/png');
            resolve(imageData);
          });
          video.currentTime = 1; // Trigger the 'seeked' event
        };
    
        video.onerror = (error) => {
          reject(`Error loading video: ${error}`);
        };
      });
        
  }

  generateURLThumbnail(url:string): Promise<string>{
    console.log("This is URL",url);
    return new Promise((resolve, reject) => {
      fetch(url)
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch file from URL: ${response.statusText}`);
          }
  
          const pdfData = new Uint8Array(await response.arrayBuffer());
          console.log("Fetched PDF data", pdfData);
  
          try {
            pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf/pdf.worker.min.js';
            // Load the PDF document
            const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
            console.log("PDF loaded", pdf);
  
            const page = await pdf.getPage(1);
            console.log("PDF page loaded", page);
  
            // Set up canvas
            const viewport = page.getViewport({ scale: 2 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d')!;
            canvas.width = viewport.width;
            canvas.height = viewport.height;
  
            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
  
            // Render the page
            await page.render(renderContext).promise;
            resolve(canvas.toDataURL()); // Return the base64 image
          } catch (error) {
            reject(`Error rendering PDF: ${error}`);
          }
        })
        .catch((error) => {
          reject(`Error fetching URL: ${error}`);
        });
    }); 

  }
 
  generateCurrentTime() {
    const currentTime = new Date();
    const options = { timeZone: 'America/Chicago' };
    const formattedTime = currentTime.toLocaleTimeString('en-US', options);
    return formattedTime;
  }

  showConfirm(message: string, callback: () => void): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: message,
      nzContent: '',
      nzOnOk: callback,
    });
  }

  setOriginalFormValue(form: FormGroup): void {
    form['_originalValue'] = { ...form.value };
  }

  hasFormChanged(form: FormGroup): boolean {
    if (!form['_originalValue']) {
      return false;
    }

    const formControls = form.controls;

    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = form['_originalValue'][controlName];
        const currentValue = formControls[controlName].value;

        if (originalValue != currentValue) {
          return true;
        }
      }
    }

    return false;
  }

  deleteAndCheckFile(fileKey, thumbnailKey) {
    console.log("This is fileKey and thumbnailKey ===>");
    console.log(fileKey);
    console.log(thumbnailKey);
    
    // Normalize input to arrays
    const fileKeys = Array.isArray(fileKey) ? fileKey : [fileKey];
    const thumbnailKeys = Array.isArray(thumbnailKey) ? thumbnailKey : [thumbnailKey];
    const deleteKeys = [...fileKeys, ...thumbnailKeys];
  
    // Construct S3 delete parameters
    const isSingleFile = deleteKeys.length === 1;
    const params = isSingleFile === false && {
          Bucket: this.bucketName,
          Delete: {
            Objects: deleteKeys.map((key) => ({ Key: key })), // Multiple files deletion
          },
        };
  
        // Perform the delete operation
        const deleteOperation = isSingleFile
        ? this.s3.deleteObject({Bucket: this.bucketName, Key: deleteKeys[0]}).promise()
        : this.s3.deleteObjects(params).promise();
        
        
        
        // Handle the promise
        return deleteOperation
        .then((data) => {
          console.log("Delete operation successful:", data);
          this.s3.getObject({Bucket:this.bucketName, Key:deleteKeys[0]}).promise().then((data)=>{
            console.log("Resource(s) not deleted, Error",data);
          }).catch((err)=> console.log("Successfully Deleted"))
        return data;
      })
      .catch((error) => {
        console.error("Delete operation failed:", error.message);
        throw error;
      });
  }
  deleteFile(fileKey){
    console.log("This is fileKey and thumbnailKey ===>");
    console.log(fileKey);

    
    // Normalize input to arrays
    const fileKeys = Array.isArray(fileKey) ? fileKey : [fileKey];
    const deleteKeys = [...fileKeys];
  
    // Construct S3 delete parameters
    const isSingleFile = deleteKeys.length === 1;
    const params = isSingleFile === false && {
          Bucket: this.bucketName,
          Delete: {
            Objects: deleteKeys.map((key) => ({ Key: key })), // Multiple files deletion
          },
        };
  
        // Perform the delete operation
        const deleteOperation = isSingleFile
        ? this.s3.deleteObject({Bucket: this.bucketName, Key: deleteKeys[0]}).promise()
        : this.s3.deleteObjects(params).promise();
        
        
        
        // Handle the promise
        return deleteOperation
        .then((data) => {
          console.log("Delete operation successful:", data);
          this.s3.getObject({Bucket:this.bucketName, Key:deleteKeys[0]}).promise().then((data)=>{
            console.log("Resource(s) not deleted, Error",data);
          }).catch((err)=> console.log("Successfully Deleted"))
        return data;
      })
      .catch((error) => {
        console.error("Delete operation failed:", error.message);
        throw error;
      });

  }
  
  //delete single file
  deleteSingleFile(fileKey) {
    console.log("This is fileKey and thumbnailKey ===>");
    console.log(fileKey);
   ;
    if(!fileKey){
      throw Error("File key is not found!");
    }
  
    // Perform the delete operation
    const deleteOperation = this.s3.deleteObject({Bucket: this.bucketName, Key: fileKey }).promise()
    
    // Handle the promise
    return deleteOperation
    .then((data) => {
      console.log("Delete operation successful:", data);
      this.s3.getObject({Bucket:this.bucketName, Key:fileKey}).promise().then((data)=>{
            console.log("Resource(s) not deleted, Error",data);
          }).catch((err)=> console.log("Successfully Deleted"))
        return data;
      })
      .catch((error) => {
        console.error("Delete operation failed:", error.message);
        throw error;
      });
  }

  // uploadFile(file: File): Promise<any> {
  //   const params = {
  //     Bucket: this.bucketName,
  //     Key: file.name, // The name of the file in S3
  //     Body: file, // The file itself
  //     ContentDisposition:"inline",
  //     ContentType:"application/pdf"
  //   };
  //     return new Promise((resolve, reject) => {
  //       this.s3.putObject(params, (err, data) => {
  //         if (err) {
  //           console.error('Error uploading file to S3:', err);
  //           reject(err);
  //         } else {
  //           console.log('File uploaded successfully to S3:', data);

  //           resolve(data);
  //         }
  //       });
  //     });
  // }

  // isFormNotEmpty(form: FormGroup): boolean {
  //   for (const controlName in form.controls) {
  //     if (form.controls.hasOwnProperty(controlName)) {
  //       const control = form.get(controlName);
  //       if (control && control.value !== null && control.value !== '') {
  //         return true;
  //       }
  //     }
  //   }

  //   return false;
  // }

  isFormNotEmpty(form: FormGroup): boolean {
    for (const controlName in form.controls) {
      if (form.controls.hasOwnProperty(controlName)) {
        const control = form.get(controlName);

        if (control) {
          if (this.hasNonEmptyValue(control.value)) {
            return true;
          }
        }
      }
    }

    return false;
  }

  hasNonEmptyValue(value: any): boolean {
    if (value === null || value === '') {
      return false;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        if (this.hasNonEmptyValue(item)) {
          return true;
        }
      }
      return false;
    }

    if (typeof value === 'object') {
      for (const key in value) {
        if (value.hasOwnProperty(key) && this.hasNonEmptyValue(value[key])) {
          return true;
        }
      }
      return false;
    }

    return true;
  }
}
